import styles from "./styles/empty.module.scss";
import { Stack, Typography } from "@mui/material";
import { useRouter } from "next/navigation";
import { Flex, Loading, Spark } from "ui";
import PropTypes from "prop-types";
import Routes from "data/routes";

const EmptyLibrary = ({ alert, ctaDisabled, loading, target }) => {
  const router = useRouter();

  if (Array.isArray(target) && target.length !== 0) return null;

  return (
    <Stack spacing={2} sx={{ width: "100%" }}>
      <Spark
        disabled={loading}
        hidden={ctaDisabled}
        onClick={() => router.push(Routes.create)}
      >
        <Typography>
          <b>Biblioteca vacía.</b> Empieza a añadir historias.
        </Typography>
      </Spark>
      <Flex className={styles.root} justifyContent="center">
        <Loading loading={loading} />
        <Typography hidden={loading}>
          {alert ||
            "Aquí podrás ver todas las historias que has creado o guardado."}
        </Typography>
      </Flex>
    </Stack>
  );
};

EmptyLibrary.propTypes = {
  alert: PropTypes.string,
  ctaDisabled: PropTypes.bool,
  loading: PropTypes.bool,
  target: PropTypes.array,
};

export default EmptyLibrary;
